import { render, staticRenderFns } from "./ModalAddEventOrganizer.vue?vue&type=template&id=60876ad8&scoped=true"
import script from "./ModalAddEventOrganizer.vue?vue&type=script&lang=js"
export * from "./ModalAddEventOrganizer.vue?vue&type=script&lang=js"
import style0 from "./ModalAddEventOrganizer.vue?vue&type=style&index=0&id=60876ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60876ad8",
  null
  
)

export default component.exports